import React from 'react';

import * as RegistryConstants from 'constants/RegistryConstants';
import {RegistrySummary} from 'constants/RegistryConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import {FilterKey, FILTERS, SingleValueFilter} from 'search/SearchConstants';
import EntityStore from 'stores/EntityStore';
import pickDefined from 'util/pickDefined';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface RegistryCollectionOwnerFilter extends SingleValueFilter {
  key: FilterKey.REGISTRY_COLLECTION_OWNER;
}
interface RegistryCollectionOwnerFilterFormProps extends BaseFilterFormProps {
  filter: RegistryCollectionOwnerFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: RegistryCollectionOwnerFilter) => void;
  onRemove?: () => void;
}
export interface RegistryCollectionOwnerFilterFormExtraProps {
  registry: RegistrySummary;
}

function RegistryCollectionOwnerFilterForm(
  props: RegistryCollectionOwnerFilterFormProps & RegistryCollectionOwnerFilterFormExtraProps
): JSX.Element {
  const myCollectionValue = EntityStore.currentUser().id;
  const orgCollectionValue = props.registry.s_owner.id;
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const name = FILTERS[FilterKey.REGISTRY_COLLECTION_OWNER].name as string;
  const optionDatas = [
    {name: 'My Collection', value: myCollectionValue},
    {name: 'Organization Collection', value: orgCollectionValue},
  ];
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText(name, optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={false}
      onChangeValue={(value: string) => {
        switch (value) {
          case orgCollectionValue:
            RegistryUtil.setCollectionPreference(RegistryConstants.DEFAULT_ORG_COLLECTION);
            break;
          case myCollectionValue:
            RegistryUtil.setCollectionPreference(RegistryConstants.DEFAULT_MY_COLLECTION);
            break;
          default:
            throw new Error(`Invalid collection owner id ${value}`);
        }
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}

export default RegistryCollectionOwnerFilterForm;
